export const DE_EMPHASIZED_OPACITY_VALUE = 0.2;
export const DE_EMPHASIZED_HEX_OPACITY_VALUE = '33';
export const TEXT_COLOR_FOR_SEMI_TRANSPARENT_BACKGROUND = '#000000';
